import { Grid } from '@material-ui/core';
import React, { FunctionComponent, useEffect, useState } from 'react';
import styles from './ActionsCell.module.scss';
import { Link, useParams } from 'react-router-dom';
import {
  EditIcon,
  TrashIcon,
  ChartIcon,
  Block,
  MakeReport,
  MakeCopyIcon,
  OuterIcon,
  UnBlock,
  ResetIcon,
  UnnecessaryIcon,
  RestartIcon,
  InfluencersHoverIcon,
  TrendingHashtag,
  BookmarkIcon,
  AddICon,
  ActiveICon,
  PausedICon,
  RemoveLinkageICon,
  MergeIcon,
  LinkageIcon,
  LangIcon,
  ImportantIcon,
  UnimportantIcon,
  HideIcon,
  DownloadActionIcon,
  Deactive,
  Active,
  IconToGroupIcon,
  PaperIcon,
  FileIcon,
} from 'app/assets/images/icons';
import ConversationIcon from 'app/assets/images/conversation.png';

import { openConfirmationPopup } from 'app/utils/confirmationPopup';
import ToolTipComp from 'app/components/ToolTipComp';
import { _t } from 'app/utils/i18n';
import useAction from 'app/hooks/useAction';
import { useModal } from 'app/context/Modal';
import Loader from 'app/components/Loader';
import {
  handleDownloadDetailedSheet,
  handleDownloadVersion,
} from 'hashtags/Requests';
import { useMutation } from 'react-query';
import { handleDownloadFile } from 'app/utils/handle-download-file';
import { checkTranslated, removeHash } from 'app/utils/helpers';
import { handleLongString } from 'app/utils/stringMethods';
import { toast } from 'react-toastify';
import { getPreSignedUrl } from 'archive/Requests';

interface ActionProps {
  cb?: () => Promise<any> | void;
  message?: string;
  runAction?: (args?: any, successMessage?: any) => void | Promise<any>;
}
interface Props {
  rowData: any;
  viewURI?: any;
  compareURI?: any;
  hideBookmark?: boolean;
  children?: any;
  deleteAction?: ActionProps;
  trashAction?: ActionProps | null;
  unBlockAction?: ActionProps;
  blockAction?: ActionProps | null;
  restoreAction?: ActionProps;
  mergeAction?: ActionProps;
  linkAction?: ActionProps;
  regrabAction?: ActionProps;
  checkAction?: ActionProps;
  openJsonAction?: ActionProps;
  openJsonActionToolTipName?: string;
  openJsonActionSettings?: ActionProps;
  openJsonActionMapping?: ActionProps;
  openJsonActionQuery?: ActionProps;
  addAction?: ActionProps | null;
  trendingHashtagAction?: (rowData: any) => void;
  topTweetsHashtagAction?: (rowData: any) => void;
  influencerAction?: (data: any) => void;
  hideChart?: boolean;
  editURI?: string;
  editURIPrams?: string;
  editAction?: (rowData: any) => void | boolean;
  sourceUrl?: string;
  addURI?: any;
  removeMr?: boolean;
  makeReport?: string;
  actionModule?: string;
  sumOfActionModule?: string;
  ActionMrTop?: boolean;
  videoMr?: boolean;
  customStyle?: any;
  alignStart?: boolean;
  unAnalyzeToAnalyzeURL?: string;
  unnecessaryAction?: ActionProps | null | undefined;
  removeLinkage?: ActionProps;
  unlinkAction?: any;
  activeStatus?: any;
  pausedStatus?: any;
  toolTipSlug?: string;
  translateText?: any;
  importantAction?: any;
  unimportantAction?: any;
  addPrams?: any;
  hideAction?: ActionProps | null;
  makeCopyAction?: ActionProps | null | undefined;
  downloadURL?: string;
  deActiveStatus?: any;
  activeReportIcon?: boolean;
  downloadVersion?: any;
  makeCloneUrl?: string;
  createFastReport?: (id: any) => void;
  moduleName?: string;
  downloadFile?: string;
  downloadFileAction?: string;
  conversationURl?: string;
  cloneAction?: (rowData: any) => void | boolean;
}
const ActionsCell: FunctionComponent<Props> = ({
  toolTipSlug,
  deActiveStatus,
  downloadURL,
  makeCopyAction,
  regrabAction,
  removeMr,
  trendingHashtagAction,
  influencerAction,
  hideBookmark,
  restoreAction,
  unBlockAction,
  activeReportIcon,
  blockAction,
  unnecessaryAction,
  rowData,
  viewURI,
  compareURI,
  deleteAction,
  trashAction,
  sumOfActionModule,
  addURI,
  addAction,
  editURI,
  editURIPrams,
  editAction,
  hideChart,
  sourceUrl,
  makeReport,
  actionModule,
  ActionMrTop,
  customStyle,
  alignStart,
  children,
  videoMr,
  unAnalyzeToAnalyzeURL,
  removeLinkage,
  activeStatus,
  pausedStatus,
  mergeAction,
  linkAction,
  unlinkAction,
  translateText,
  importantAction,
  unimportantAction,
  addPrams,
  hideAction,
  downloadVersion,
  topTweetsHashtagAction,
  makeCloneUrl,
  createFastReport,
  moduleName,
  downloadFile,
  downloadFileAction,
  conversationURl,
  cloneAction,
  openJsonAction,
  openJsonActionSettings,
  openJsonActionMapping,
  openJsonActionQuery,
  checkAction,
  openJsonActionToolTipName,
}) => {
  const { fireAction } = useAction();
  const modal = useModal();
  const [enableAction, setEnableAction] = useState(true);
  const [enableAddAction, setEnableAddAction] = useState(true);
  const [enableRegrabAction, setEnableRegrabAction] = useState(true);
  useEffect(() => {
    setEnableRegrabAction(true);
    setEnableAddAction(true);
    setEnableAction(true);
  }, [rowData]);
  const { mutate: downloadReport } = useMutation(handleDownloadDetailedSheet, {
    onSuccess: ({ payload }) => {
      modal.show({
        message: _t(
          `reports:working_on_downloading_you_will_be_notified_once_finished`,
          {
            report_name: payload?.report_name,
            template_name: payload?.template_name,
          },
        ),
        onCancelText: _t('basic:ok'),
      });
    },
    onError: (err: any) => {
      modal.hide();
      toast.error(err?.response?.data?.message);
    },
  });
  const { mutate: downloadReportVersion } = useMutation(handleDownloadVersion, {
    onSuccess: ({ payload }) => {
      downloadVersion();
      handleDownloadFile(payload?.url);
    },
  });
  const { mutate: getPreSignedUrlMutate } = useMutation(getPreSignedUrl, {
    onSuccess: ({ payload }) => {
      handleDownloadFile(payload);
      downloadVersion?.();
    },
  });

  const downloadReportHandler = (isRegrab: boolean) => {
    downloadReport({ id: { value: downloadURL }, regrab: isRegrab });
  };

  const downloadReportModal = () =>
    modal.show({
      message:
        moduleName === 'ENTITIES'
          ? _t(`reports:about_to_download_report_entity`)
          : moduleName === 'HASHTAGS'
            ? _t(`reports:about_to_download_report_hashtag`)
            : _t(`reports:about_to_download_report_influencer`),
      onOkText: _t('reports:download'),
      onCancelText: _t('reports:cancel'),
      onCancel: () => {
        modal.hide();
      },
      onOk: (a, b, isRegrab) => downloadReportHandler(isRegrab),
      checkboxCondition: _t('influencers:regrab_before_download'),
    });
  const downloadAll = () => {
    downloadReportVersion({ id: rowData?.id });
  };
  const downloadUrlAction = (url: any) => {
    getPreSignedUrlMutate({ url: url });
  };

  const params = useParams<any>();
  return (
    <Grid
      container
      justifyContent="flex-start"
      className={`${styles.ActionsCell} ${removeMr ? styles.ActionMr : null} ${
        customStyle && styles.alignIcons
      } ${alignStart && styles.alignStart} ${ActionMrTop && styles.ActionMrTop}
      ${videoMr && styles.videoMr}
      }`}
      alignItems="center"
      data-testid="action-cell"
    >
      {createFastReport && (
        <ToolTipComp title={_t('reports:download_fast_report')}>
          <Grid item data-testid="action-cell-chart">
            <div onClick={() => createFastReport(rowData?.id)}>
              <PaperIcon />
            </div>
          </Grid>
        </ToolTipComp>
      )}
      {!hideChart ? (
        <ToolTipComp title={_t('basic:chart')}>
          <Grid item data-testid="action-cell-chart">
            <Link
              to={`${viewURI}/${rowData?.id}${addPrams ? '/' + addPrams : ''}`}
            >
              <ChartIcon />
            </Link>
          </Grid>
        </ToolTipComp>
      ) : null}
      {sourceUrl ? (
        <ToolTipComp title={_t('basic:open_in_source')}>
          <Grid item data-testid="action-cell-source">
            <a rel="noreferrer" target="_blank" href={sourceUrl}>
              <OuterIcon />
            </a>
          </Grid>
        </ToolTipComp>
      ) : null}
      {openJsonAction ? (
        <ToolTipComp
          title={openJsonActionToolTipName || _t('basic:open_response')}
        >
          <span onClick={() => openJsonAction.runAction?.()}>
            <FileIcon />
          </span>
        </ToolTipComp>
      ) : null}
      {openJsonActionMapping ? (
        <ToolTipComp title={_t('basic:open_mapping')}>
          <span onClick={() => openJsonActionMapping.runAction?.()}>
            <FileIcon />
          </span>
        </ToolTipComp>
      ) : null}
      {openJsonActionQuery ? (
        <ToolTipComp title={_t('basic:open_query')}>
          <span onClick={() => openJsonActionQuery.runAction?.()}>
            <FileIcon />
          </span>
        </ToolTipComp>
      ) : null}
      {openJsonActionSettings ? (
        <ToolTipComp title={_t('basic:open_settings')}>
          <span onClick={() => openJsonActionSettings.runAction?.()}>
            <FileIcon />
          </span>
        </ToolTipComp>
      ) : null}
      {addURI || addAction ? (
        <ToolTipComp title={_t('basic:add')}>
          <Grid item data-testid="action-cell-add">
            {addAction ? (
              unAnalyzeToAnalyzeURL ? (
                <Link
                  to={`${unAnalyzeToAnalyzeURL}/${rowData?.id}`}
                  onClick={() => {
                    fireAction({
                      runAction: async () => {
                        await addAction?.runAction?.(
                          rowData?.id,
                          addAction.message,
                        );
                        addAction?.cb?.();
                      },
                    });
                  }}
                >
                  <AddICon />
                </Link>
              ) : (
                <div
                  onClick={() => {
                    fireAction({
                      runAction: async () => {
                        try {
                          setEnableAddAction(false);
                          document.body.classList.remove('no-Events');
                          await addAction?.runAction?.(
                            rowData?.id,
                            addAction.message,
                          );
                          addAction?.cb?.();
                          setEnableAddAction(true);
                        } catch (error) {
                          setEnableAddAction(true);
                          document.body.classList.remove('no-Events');
                        }
                      },
                    });
                  }}
                >
                  {enableAddAction ? (
                    <AddICon />
                  ) : (
                    <div className={styles.regrabLoader}>
                      <Loader smallSize />
                    </div>
                  )}
                </div>
              )
            ) : (
              <Link to={`${addURI}/${rowData?.id}`}>
                <AddICon />
              </Link>
            )}
          </Grid>
        </ToolTipComp>
      ) : null}
      {editAction || editURI ? (
        <ToolTipComp title={_t('basic:edit')}>
          <Grid item data-testid="action-cell-edit">
            {editURI ? (
              <Link
                to={`${editURI}/${editURIPrams ? editURIPrams + '/' : ''}${
                  rowData?.id
                }`}
              >
                <EditIcon />
              </Link>
            ) : (
              <div onClick={() => editAction?.(rowData)}>
                <EditIcon />
              </div>
            )}
          </Grid>
        </ToolTipComp>
      ) : null}
      {activeStatus ? (
        <ToolTipComp title={_t('news:active')}>
          <div
            onClick={() => {
              fireAction({
                runAction: async () => {
                  await activeStatus?.runAction?.(
                    rowData?.id,
                    activeStatus.message,
                  );
                  activeStatus?.cb?.();
                },
              });
            }}
          >
            {activeReportIcon ? <Active /> : <ActiveICon />}
          </div>
        </ToolTipComp>
      ) : null}
      {deActiveStatus ? (
        <ToolTipComp title={_t('reports:deactive')}>
          <div
            data-testid="action-cell-deActive-status"
            onClick={() => {
              openConfirmationPopup(
                modal,
                'deactive',
                actionModule,
                sumOfActionModule,
                () =>
                  fireAction({
                    runAction: async () => {
                      await deActiveStatus?.runAction?.(
                        rowData?.id,
                        deActiveStatus.message,
                      );
                      deActiveStatus?.cb?.();
                    },
                  }),
              );
            }}
          >
            <Deactive />
          </div>
        </ToolTipComp>
      ) : null}

      {!!downloadURL && (
        <ToolTipComp title={_t('reports:download')}>
          <Grid item>
            <DownloadActionIcon onClick={downloadReportModal} />
          </Grid>
        </ToolTipComp>
      )}
      {!!downloadFile && (
        <ToolTipComp title={_t('reports:download')}>
          <Grid item>
            <DownloadActionIcon
              onClick={() => handleDownloadFile(downloadFile)}
            />
          </Grid>
        </ToolTipComp>
      )}
      {!!downloadFileAction && (
        <ToolTipComp title={_t('reports:download')}>
          <Grid item>
            <DownloadActionIcon
              onClick={() => downloadUrlAction(downloadFileAction)}
            />
          </Grid>
        </ToolTipComp>
      )}

      {downloadVersion && !downloadFileAction ? (
        <ToolTipComp title={_t('reports:download')}>
          <Grid item data-testid="action-cell-download">
            <DownloadActionIcon onClick={() => downloadAll()} />
          </Grid>
        </ToolTipComp>
      ) : null}
      {pausedStatus ? (
        <ToolTipComp title={_t('news:paused')}>
          <div
            onClick={() => {
              fireAction({
                runAction: async () => {
                  await pausedStatus?.runAction?.(
                    rowData?.id,
                    pausedStatus.message,
                  );
                  pausedStatus?.cb?.();
                },
              });
            }}
          >
            <PausedICon />
          </div>
        </ToolTipComp>
      ) : null}
      {blockAction ? (
        <ToolTipComp title={_t('basic:block')}>
          <Grid item data-testid="action-cell-block">
            <div
              onClick={() => {
                openConfirmationPopup(
                  modal,
                  'block',
                  actionModule,
                  sumOfActionModule,
                  (message) =>
                    fireAction({
                      runAction: async () => {
                        await blockAction?.runAction?.(rowData?.id, message);
                        blockAction?.cb?.();
                      },
                    }),
                );
              }}
            >
              <Block />
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {unBlockAction ? (
        <ToolTipComp title={_t('basic:un_block')}>
          <Grid item>
            <div
              onClick={() => {
                fireAction({
                  runAction: async () => {
                    await unBlockAction?.runAction?.(
                      rowData?.id,
                      unBlockAction.message,
                    );
                    unBlockAction?.cb?.();
                  },
                });
              }}
            >
              <UnBlock />
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {children}
      {removeLinkage ? (
        <ToolTipComp title={_t('news:remove_linkage')}>
          <Grid item data-testid="action-cell-remove-Link-age">
            <div
              onClick={() => {
                openConfirmationPopup(
                  modal,
                  'removeLinkage',
                  actionModule,
                  sumOfActionModule,
                  (message) =>
                    fireAction({
                      runAction: async () => {
                        try {
                          await removeLinkage?.runAction?.(
                            rowData?.id,
                            message,
                          );
                          removeLinkage?.cb?.();
                        } catch (error) {
                          document.body.classList.remove('no-Events');
                        }
                      },
                    }),
                );
              }}
            >
              <RemoveLinkageICon />
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {compareURI ? (
        <Grid item className={styles.versus} data-testid="action-cell-compare">
          <ToolTipComp title={_t('basic:Compare')}>
            <Link
              to={{
                pathname: compareURI,
                state: [rowData],
              }}
              className="link-without-hover"
            >
              <span>V.S.</span>
            </Link>
          </ToolTipComp>
        </Grid>
      ) : null}
      {makeCopyAction ? (
        <ToolTipComp title={_t('reports:clone')}>
          <Grid item data-testid="action-cell-make-copy">
            <div
              onClick={() => {
                fireAction({
                  runAction: async () => {
                    await makeCopyAction?.runAction?.(
                      rowData?.id,
                      makeCopyAction.message,
                    );
                    makeCopyAction?.cb?.();
                  },
                });
              }}
            >
              <MakeCopyIcon />
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {cloneAction || makeCloneUrl ? (
        <ToolTipComp title={_t('archive:clone')}>
          <Grid item data-testid="action-cell-make-copy">
            {makeCloneUrl ? (
              <Link to={makeCloneUrl}>
                <MakeCopyIcon />
              </Link>
            ) : (
              <div onClick={() => cloneAction?.(rowData)}>
                <MakeCopyIcon />
              </div>
            )}
          </Grid>
        </ToolTipComp>
      ) : null}
      {conversationURl ? (
        <ToolTipComp title={_t('influencers:conversation')}>
          <Grid item data-testid="action-cell-make-conversation-url">
            <Link to={conversationURl}>
              <img src={ConversationIcon} />
            </Link>
          </Grid>
        </ToolTipComp>
      ) : null}
      {trashAction ? (
        <ToolTipComp title={_t('basic:trash')}>
          <Grid item>
            <div
              onClick={
                enableAction
                  ? () => {
                      openConfirmationPopup(
                        modal,
                        'trash',
                        actionModule,
                        sumOfActionModule,
                        (message) =>
                          fireAction({
                            runAction: async () => {
                              try {
                                setEnableAction(false);
                                await trashAction?.runAction?.(
                                  rowData?.id,
                                  message,
                                );
                                trashAction
                                  ?.cb?.()
                                  ?.then(() => setEnableAction(true));
                              } catch (error) {
                                setEnableAction(true);
                              }
                            },
                          }),
                        () => {
                          setEnableAction(true);
                          modal.hide();
                        },
                        rowData.sub_category_count,
                      );
                    }
                  : undefined
              }
            >
              {enableAction ? (
                <TrashIcon />
              ) : (
                <div className={styles.actionLoader}>
                  <Loader smallSize />
                </div>
              )}
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {/* hideAction Do trash or unncessary */}
      {hideAction ? (
        <ToolTipComp title={_t('basic:hide')}>
          <Grid item data-testid="action-cell-hide">
            <div
              onClick={
                enableAction
                  ? () => {
                      openConfirmationPopup(
                        modal,
                        'hide',
                        actionModule,
                        sumOfActionModule,
                        (message) =>
                          fireAction({
                            runAction: async () => {
                              try {
                                setEnableAction(false);

                                await hideAction?.runAction?.(
                                  rowData?.id,
                                  message,
                                );
                                hideAction
                                  ?.cb?.()
                                  ?.then(() => setEnableAction(true));
                              } catch (error) {
                                setEnableAction(true);
                              }
                            },
                          }),
                        () => {
                          setEnableAction(true);
                          modal.hide();
                        },
                      );
                    }
                  : undefined
              }
            >
              {enableAction ? (
                <HideIcon />
              ) : (
                <div className={styles.actionLoader}>
                  <Loader smallSize />
                </div>
              )}
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {mergeAction ? (
        <ToolTipComp title={_t('basic:merge')}>
          <Grid item data-testid="action-cell-merge">
            <div
              onClick={() => {
                fireAction({
                  runAction: () => {
                    mergeAction?.runAction?.(rowData?.id);
                    mergeAction?.cb?.();
                  },
                });
                () => {
                  setEnableAction(true);
                  modal.hide();
                };
              }}
            >
              <MergeIcon />
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {linkAction ? (
        <ToolTipComp title={_t('basic:link')}>
          <Grid item data-testid="action-cell-link">
            <div
              onClick={() => {
                fireAction({
                  runAction: () => linkAction?.runAction?.(rowData?.id),
                });
              }}
            >
              {<LinkageIcon />}
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {unlinkAction ? (
        <ToolTipComp title={_t('basic:unlink')}>
          <Grid item data-testid="action-cell-unlink">
            <div
              onClick={() => {
                fireAction({
                  runAction: async () => {
                    await unlinkAction?.runAction?.(rowData?.id, params?.id);
                    unlinkAction?.cb?.();
                  },
                });
              }}
            >
              <RemoveLinkageICon />
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {restoreAction ? (
        <ToolTipComp title={_t('basic:restore')}>
          <Grid item data-testid="action-cell-restore">
            <div
              onClick={
                enableAction
                  ? () => {
                      setEnableAction(false);
                      fireAction({
                        runAction: async () => {
                          try {
                            await restoreAction?.runAction?.(
                              rowData?.id,
                              restoreAction?.message,
                            );
                            restoreAction
                              ?.cb?.()
                              ?.then(() => setEnableAction(true));
                          } catch (error) {
                            setEnableAction(true);
                          }
                        },
                      });
                    }
                  : undefined
              }
            >
              {enableAction ? (
                <ResetIcon />
              ) : (
                <div className={styles.actionLoader}>
                  <Loader smallSize />
                </div>
              )}
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {deleteAction ? (
        <ToolTipComp title={_t('influencers:delete')}>
          <Grid item data-testid="action-cell-delete">
            <div
              onClick={
                enableAction
                  ? () => {
                      openConfirmationPopup(
                        modal,
                        'delete',
                        actionModule,
                        sumOfActionModule,
                        (message) =>
                          fireAction({
                            runAction: async () => {
                              try {
                                setEnableAction(false);
                                await deleteAction?.runAction?.(
                                  rowData?.id,
                                  message,
                                );
                                deleteAction?.cb?.();
                              } catch (error) {
                                setEnableAction(true);
                              }
                            },
                          }),
                        () => {
                          setEnableAction(true);
                          modal.hide();
                        },
                      );
                    }
                  : undefined
              }
            >
              {enableAction ? (
                <TrashIcon />
              ) : (
                <div className={styles.actionLoader}>
                  <Loader smallSize />
                </div>
              )}
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {influencerAction && (
        <ToolTipComp title={toolTipSlug || ''}>
          <Grid item>
            <div onClick={() => influencerAction(rowData)}>
              <InfluencersHoverIcon />
            </div>
          </Grid>
        </ToolTipComp>
      )}
      {trendingHashtagAction && (
        <ToolTipComp title={_t('basic:trending_hashtag')}>
          <Grid item>
            <div onClick={() => trendingHashtagAction(rowData)}>
              <TrendingHashtag />
            </div>
          </Grid>
        </ToolTipComp>
      )}

      {topTweetsHashtagAction && (
        <ToolTipComp title={_t('influencers:items_to_group')}>
          <Grid item>
            <div onClick={() => topTweetsHashtagAction(rowData)}>
              <IconToGroupIcon />
            </div>
          </Grid>
        </ToolTipComp>
      )}
      {unnecessaryAction ? (
        <ToolTipComp title={_t('basic:unnecessary')}>
          <Grid item data-testid="action-cell-unnecessary">
            <div
              onClick={
                enableAction
                  ? () => {
                      openConfirmationPopup(
                        modal,
                        'unnecessary',
                        actionModule,
                        sumOfActionModule,
                        (message) =>
                          fireAction({
                            runAction: async () => {
                              try {
                                setEnableAction(false);

                                await unnecessaryAction?.runAction?.(
                                  rowData?.id,
                                  message,
                                );
                                unnecessaryAction
                                  ?.cb?.()
                                  ?.then(() => setEnableAction(true));
                              } catch (error) {
                                setEnableAction(true);
                              }
                            },
                          }),
                        () => {
                          setEnableAction(true);
                          modal.hide();
                        },
                      );
                    }
                  : undefined
              }
            >
              {enableAction ? (
                <UnnecessaryIcon />
              ) : (
                <div className={styles.actionLoader}>
                  <Loader smallSize />
                </div>
              )}
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {regrabAction ? (
        <ToolTipComp title={_t('basic:regrab')}>
          <Grid item>
            <div
              onClick={
                enableRegrabAction
                  ? () => {
                      openConfirmationPopup(
                        modal,
                        'regrab',
                        actionModule,
                        sumOfActionModule,
                        (message) =>
                          fireAction({
                            runAction: async () => {
                              try {
                                setEnableRegrabAction(false);
                                document.body.classList.remove('no-Events');
                                await regrabAction?.runAction?.(
                                  rowData?.id,
                                  message,
                                );
                                regrabAction?.cb?.();
                                setEnableRegrabAction(true);
                              } catch (error) {
                                setEnableRegrabAction(true);
                                document.body.classList.remove('no-Events');
                              }
                            },
                          }),
                        undefined,
                        undefined,
                        true,
                        _t('basic:ok'),
                        `${_t('basic:working_on_grabbing')} ${
                          actionModule ? actionModule : ''
                        } (${handleLongString(
                          checkTranslated(
                            removeHash(rowData?.hashtag_name) ||
                              rowData.title ||
                              rowData?.remote_id ||
                              rowData?.post_code ||
                              rowData?.post_remote_id ||
                              rowData?.name?.original,
                            removeHash(rowData?.hashtag_name_translated) ||
                              rowData.title_translated ||
                              rowData?.name?.arabic ||
                              rowData?.post_code ||
                              rowData?.post_remote_id ||
                              rowData?.remote_id,
                          ),
                        )} )${_t('basic:you_will_be_notified')}`,
                      );
                    }
                  : undefined
              }
            >
              {enableRegrabAction ? (
                <RestartIcon />
              ) : (
                <div className={styles.regrabLoader}>
                  <Loader smallSize />
                </div>
              )}
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {checkAction ? (
        <ToolTipComp title={_t('basic:check')}>
          <Grid item>
            <div
              onClick={() => {
                openConfirmationPopup(
                  modal,
                  'check',
                  actionModule,
                  sumOfActionModule,
                  () =>
                    fireAction({
                      runAction: async () => {
                        try {
                          document.body.classList.remove('no-Events');
                          await checkAction?.runAction?.(rowData?.id);
                          checkAction?.cb?.();
                        } catch (error) {
                          document.body.classList.remove('no-Events');
                        }
                      },
                    }),
                  undefined,
                  undefined,
                  true,
                  _t('basic:ok'),
                  `${_t('basic:working_on_checking')} ${
                    actionModule ? actionModule : ''
                  } (${handleLongString(
                    rowData?.sample_source_url,
                  )} )${_t('basic:you_will_be_notified')}`,
                );
              }}
            >
              <RestartIcon />
            </div>
          </Grid>
        </ToolTipComp>
      ) : null}
      {!hideBookmark ? (
        <ToolTipComp title={_t('basic:bookmark')}>
          <Grid item data-testid="action-cell-bookmark">
            <BookmarkIcon />
          </Grid>
        </ToolTipComp>
      ) : null}
      {importantAction ? (
        <ToolTipComp title={_t('basic:important')}>
          <div
            data-testid="action-cell-important"
            onClick={
              enableAction
                ? () => {
                    setEnableAction(false);
                    fireAction({
                      runAction: async () => {
                        try {
                          await importantAction?.runAction?.(
                            rowData?.id,
                            importantAction.message,
                          );
                          importantAction?.cb?.().then(setEnableAction(true));
                        } catch (error) {
                          setEnableAction(true);
                        }
                      },
                    });
                  }
                : undefined
            }
          >
            {enableAction ? (
              <ImportantIcon />
            ) : (
              <div className={styles.actionLoader}>
                <Loader smallSize />
              </div>
            )}
          </div>
        </ToolTipComp>
      ) : null}
      {unimportantAction ? (
        <ToolTipComp title={_t('basic:unimportant')}>
          <div
            data-testid="action-cell-unimportant"
            onClick={() => {
              fireAction({
                runAction: async () => {
                  await unimportantAction?.runAction?.(
                    rowData?.id,
                    unimportantAction.message,
                  );
                  unimportantAction?.cb?.();
                },
              });
            }}
          >
            <UnimportantIcon />
          </div>
        </ToolTipComp>
      ) : null}
      {makeReport ? (
        <ToolTipComp title={_t('basic:make_report')}>
          <Grid item data-testid="action-cell-make-report">
            <Link to={makeReport}>
              <MakeReport />
            </Link>
          </Grid>
        </ToolTipComp>
      ) : null}
      {translateText ? (
        <ToolTipComp title={translateText}>
          <Grid item data-testid="action-cell-translate-text">
            <LangIcon />
          </Grid>
        </ToolTipComp>
      ) : null}
    </Grid>
  );
};

export default ActionsCell;
